import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Standards from "@/pages/Standards";
import Certification from "@/pages/Certification";
import Registry from "@/pages/Registry";
import RegistryApply from "@/pages/RegistryApply";
import PractitionerProfile from "@/pages/PractitionerProfile";
import Education from "@/pages/Education";
import Textbook from "@/pages/Textbook";
import Gallery from "@/pages/Gallery";
import CaseDetail from "@/pages/CaseDetail";
import Healthcare from "@/pages/Healthcare";
import Resources from "@/pages/Resources";
import News from "@/pages/News";
import NewsArticle from "@/pages/NewsArticle";
import Contact from "@/pages/Contact";
import Consultation from "@/pages/Consultation";
import Login from "@/pages/Login";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/admin/login" element={<Login />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/standards" element={<Standards />} />
            <Route path="/certification" element={<Certification />} />
            <Route path="/registry" element={<Registry />} />
            <Route path="/registry/apply" element={<RegistryApply />} />
            <Route path="/registry/:id" element={<PractitionerProfile />} />
            <Route path="/education" element={<Education />} />
            <Route path="/textbook" element={<Textbook />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/gallery/:id" element={<CaseDetail />} />
            <Route path="/healthcare" element={<Healthcare />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/news" element={<News />} />
            <Route path="/news/:slug" element={<NewsArticle />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/consultation" element={<Consultation />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
